import { COGNITIVE_STATUS_GROUPS } from "./initial-f2f-cognitive-constant";
import { FUNCTIONAL_HOMEBOUND_GROUPS } from "./initial-f2f-objective-constant";
import { PLAN_OF_CARE_GROUPS } from "./initial-f2f-plan-constant";
import {
  ADVANCE_DIRECTIVE_GROUPS,
  HOME_HEALTH_ORDER_GROUPS,
  PATIENT_INSTRUCTION_GROUPS,
  FACE_TO_FACE_GROUPS,
  START_OF_CARE_GROUPS,
} from "./initial-f2f-plan-text-constant";

// Shorter options ("yes", "Refer for LVN") are found by comma splitting; only sentence-length ones need matching.
const STATEMENT_MIN_WORDS = 4;

const wordCount = (text: string) => text.trim().split(/\s+/).length;

// The note text drops a statement's closing dot before joining, so the catalog stores statements without it.
const withoutClosingDot = (option: string) => option.trim().replace(/\.$/, "");

/**
 * Every checkbox statement the Premier MD templates can emit, so a report line
 * that the backend joined with commas can be cut back into one bullet per statement.
 */
const ALL_OPTIONS: string[] = Array.from(
  new Set(
    [
      FUNCTIONAL_HOMEBOUND_GROUPS,
      COGNITIVE_STATUS_GROUPS,
      PLAN_OF_CARE_GROUPS,
      ADVANCE_DIRECTIVE_GROUPS,
      PATIENT_INSTRUCTION_GROUPS,
      FACE_TO_FACE_GROUPS,
      HOME_HEALTH_ORDER_GROUPS,
      START_OF_CARE_GROUPS,
    ]
      .flat()
      .flatMap((group) => group.options)
      .map(withoutClosingDot)
  )
);

export const INITIAL_F2F_STATEMENT_CATALOG: string[] = ALL_OPTIONS.filter(
  (option) => wordCount(option) >= STATEMENT_MIN_WORDS
).sort((a, b) => b.length - a.length);

/** Every option, lower-cased, so loose text between statements can be told apart from a typed note. */
export const INITIAL_F2F_OPTION_SET: ReadonlySet<string> = new Set(
  ALL_OPTIONS.map((option) => option.toLowerCase())
);
